import React, { useState, useEffect } from "react";
import Modal from "react-modal";

import UploadArea from "Components/Form/UploadArea";
import DetailsOrdersErrorsModal from "Components/Modals/DetailsOrdersErrorsModal";
import PageWrapper from "Components/Pages/Wrapper";
import Breadcrumb from "Components/Shared/Breadcrumb";

import UploadIcon from "Assets/Images/upload.png";

import { Pagination } from "Components/Pagination";
import { getPersonImports } from "Requests/Person";
import { createToast } from "Utils/toastFunc";
import { Button } from "Components/Button";
import { Box } from "styles/globalComponents";
import { Header, NavWrapper, PaginationWrapper } from "./styles";
import { TableItems } from "./components/Table";

const ImportPersons = () => {
  const [modalErrorCode, setModalErrorCode] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [dataModal, setDataModal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imported_orders, setImportedOrders] = useState([]);
  const [pagination, setPagination] = useState<any>({});
  const [pageActive, setPageActive] = useState(0);
  const [lastPagePagination, setLastPagePagination] = useState(1);

  function handleUploadModal() {
    setIsUploadModalVisible(!isUploadModalVisible);
  }

  async function fetchImportedOrders(page = 1) {
    setLoading(true);

    try {
      const response = await getPersonImports();

      const { data } = response.data;

      setPagination(pagination || {});
      setPageActive(pagination.current_page || page);
      setImportedOrders(data);
    } catch (err: any) {
      const errorMessage = err.response.data.message;
      createToast("error", errorMessage);
    } finally {
      setLoading(false);
    }
  }

  async function sendFileFinished(response: any) {
    setIsUploadModalVisible(false);
    fetchImportedOrders();
  }

  function handlePagination(e: any) {
    if (lastPagePagination === e.currentPage) return;

    fetchImportedOrders(e.currentPage);
    setLastPagePagination(e.currentPage);
  }

  const onError = (error: string) => {
    createToast("error", error);
  };

  const handleDownloadModel = async () => {
    try {
      // Busca o arquivo da pasta public
      const fileUrl = `${
        process.env.PUBLIC_URL || ""
      }/modelo-importacao-pessoas.xlsx`;
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error("Arquivo não encontrado");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "modelo-importacao-pessoas.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      createToast("success", "Download do modelo concluído com sucesso!");
    } catch (error) {
      console.error("Erro ao fazer download do modelo:", error);
      createToast("error", "Erro ao fazer download do modelo");
    }
  };

  useEffect(() => {
    fetchImportedOrders();
  }, []);

  return (
    <PageWrapper className="entry-app-content">
      <Modal
        isOpen={isUploadModalVisible}
        onRequestClose={handleUploadModal}
        bodyOpenClassName="modal-content-open"
        overlayClassName={{
          base: "modal",
          afterOpen: "after-open",
          beforeClose: "before-close",
        }}
        className="upload-modal"
        closeTimeoutMS={500}
      >
        <div>
          <img src={UploadIcon} alt="Upload" />
          <h1>Fazer upload</h1>
          <UploadArea
            formDataFileString="file"
            importPath="/import/persons"
            allowExtensions={["xlsx", "xls", "csv"]}
            finished={sendFileFinished}
            onError={onError}
          />
        </div>
      </Modal>
      <DetailsOrdersErrorsModal
        modalErrorCode={modalErrorCode}
        modalVisible={modalVisible}
        modalDismiss={() => setModalVisible(false)}
        loading={loadingModal}
        data={dataModal}
      />
      <div className="content-holder">
        <Header>
          <h1>Importar Pessoas</h1>
          <Breadcrumb
            list={[
              {
                path: "/pessoas",
                label: "PESSOAS",
                current: false,
              },
              {
                path: "#",
                label: "IMPORTAR PESSOAS",
                current: true,
              },
            ]}
          />
        </Header>

        <NavWrapper>
          <div className="page-content-list">
            <TableItems imported_orders={imported_orders} loading={loading} />
          </div>
        </NavWrapper>
      </div>
      <PaginationWrapper>
        {!loading && (
          <>
            <Pagination
              totalRecords={pagination?.total_pages}
              currentPageSelected={pagination?.current_page}
              pageLimit={1}
              pageNeighbours={1}
              onPageChanged={(e) => handlePagination(e)}
            />
          </>
        )}

        <Box display="flex" justify="space-between">
          <Button onClick={handleDownloadModel}>
            Download modelo planilha
          </Button>

          <button className="button yellow" onClick={handleUploadModal}>
            Importar pessoas
          </button>
        </Box>
      </PaginationWrapper>
    </PageWrapper>
  );
};

export default ImportPersons;
